const prefix = '/materiality-assessments';

export const LAYOUTS_MA = `${prefix}`;
export const LAYOUTS_MA_RECORD = `${prefix}/{maId}/sections`;
export const LAYOUTS_MA_RECORD_TYPE = `${prefix}/{maId}/sections/{type}`;
export const LAYOUTS_MA_RECORD_TYPE_DETAILS = `${prefix}/{maId}/sections/{type}`;

export default LAYOUTS_MA;
